import React from 'react';
import PropTypes from 'prop-types';

import { faUsers } from '@fortawesome/pro-solid-svg-icons';

import PageHeader from 'components/page_header';
import FilterTopbar from 'components/search_page/filter_topbar';
import FilterRow from 'components/search_page/filter_row';
import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';
import SelectableRecordTable from 'components/selectable_record_table/selectable_record_table';
import SelectableRow from 'components/selectable_record_table/selectable_row';
import FilterButton from 'components/search_sidebar/filter_button';

const contacts = [
  {
    name: "Theo",
    jobTitle: "Canada Man",
    phone: "12345678987",
    email: "canandaman@buildout.com"
  },
  {
    name: "Harrison",
    jobTitle: "UX Guy",
    phone: "16548498465",
    email: "uxguy@buildout.com"
  },
  {
    name: "Ben",
    jobTitle: "Developer #1",
    phone: "49687896465",
    email: "developer1@buildout.com"
  },
  {
    name: "Dan",
    jobTitle: "Developer #2",
    phone: "49687896465",
    email: "developer2@buildout.com"
  },
  {
    name: "Chris",
    jobTitle: "Developer #3",
    phone: "49687896465",
    email: "developer3@buildout.com"
  },
  {
    name: "Shivank",
    jobTitle: "Developer #4",
    phone: "49687896465",
    email: "developer4@buildout.com"
  }
];

const filterOptions = [
  {
    id: 1,
    value: "office",
    label: "Office"
  },
  {
    id: 2,
    value: "land",
    label: "Land"
  },
  {
    id: 3,
    value: "yeet",
    label: "Yeet"
  },
  {
    id: 4,
    value: "skrt",
    label: "Skrrrrttt"
  }
];

export default class IndexTableSample extends React.Component {
  static propTypes = {
    styleGuidePath: PropTypes.string.isRequired
  }

  state = {
    searchText: ""
  }

  moveToTab = (key) => {
    this.setState({ activeTab: key });
  }

  handleSearchChange = e => this.setState({ searchText: e.target.value });

  renderRows() {
    const rows = [];
    contacts.map((contact) => {
      rows.push(
        <SelectableRow key={contact.name}>
          <td>{contact.name}</td>
          <td>{contact.jobTitle}</td>
          <td>{contact.phone}</td>
          <td>{contact.email}</td>
        </SelectableRow>
      );
    });
    return rows;
  }

  renderTable() {
    const columnHeaders = (
      <React.Fragment>
        <th>Name</th>
        <th>Job Title</th>
        <th>Phone Number</th>
        <th>Email</th>
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <SelectableRecordTable
          columnHeaders={columnHeaders}
        >
          {this.renderRows()}
        </SelectableRecordTable>
      </React.Fragment>
    );
  }

  renderPropertyTypeButton() {
    return (
      <FilterButton
        filtersApplied
        label="Property Type"
      >
        <FilterCheckboxGroup
          options={filterOptions}
          selected={["land", "yeet"]}
        />
      </FilterButton>
    );
  }

  renderFilters() {
    const { searchText } = this.state;

    return (
      <FilterRow
        searchPlaceHolder="Search by name or company"
        searchText={searchText}
        onSearchChange={this.handleSearchChange}
      >
        {this.renderPropertyTypeButton()}
      </FilterRow>
    );
  }

  render() {
    return (
      <div className='search-page'>
        <div className='results-tab-container'>
          <PageHeader
            iconDescription="Manage your contact database"
            iconName={faUsers}
            iconSize="lg"
            iconText="Contacts"
            iconType="icon"
          >
            <a className='btn btn-dark' href={this.props.styleGuidePath}>
              Back to Style Guide
            </a>
          </PageHeader>
          <FilterTopbar>
            <div>{this.renderFilters()}</div>
          </FilterTopbar>
          <div className="table-content">
            <div className="main-content">
              {this.renderTable()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
